import React from 'react'

const TextTemplate: React.FC<any> = ({ message, side }) => {
  return (
    <>
      <p
        dangerouslySetInnerHTML={{ __html: message }}
        className={`p-5 mb-0 rounded bg-light-${
          side === 'rhs' || side === undefined ? 'primary' : 'info'
        } text-dark fw-bold mw-lg-600px text-${side === 'center' ? 'center' : 'start'}`}
      />
      {side === 'lhs' && <i className='bi bi-check-all'></i>}
    </>
  )
}

export default TextTemplate
